import React from "react";
import EventGalleryPage from "../../components/EventGalleryPage";
import { eventGalleries } from "../../data/galleries";

export default function Cradles() {
  return (
    <EventGalleryPage
      imageLabel="Cradle"
      cloudinaryFolder="images/cradleceremony"
      images={eventGalleries.cradle}
      intro={{
        iconImg: "/cradle-icon1.png",
        iconSize: "h-24",
        title: "Welcome Your Little One With Love",
        subtitle: "Celebrate your baby's arrival with charming decor that captures the joy of new beginnings.",
      }}
    />
  );
}
